<div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; width: 100%; background-color: #f2f0f0;">
  <mat-card class="login-form">
    <h2 style="text-align: center">Login with:</h2>
    <mat-form-field class="login-field-wrap">
      <mat-label>Email:</mat-label>
      <input matInput type="email" placeholder="Email" [(ngModel)]="credentials.username" name="email" (keyup.enter)="passwordInput.focus()">
    </mat-form-field>
    <mat-form-field class="login-field-wrap">
      <mat-label>Password:</mat-label>
      <input matInput type="password" placeholder="Password" [(ngModel)]="credentials.textMessage" name="textMessage" (keyup.enter)="onSubmit()" #passwordInput>
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="onSubmit()">Sign in</button>
    <div class="recover-password" (click)="forgotPasswordClick()">Forgot your password?</div>
    <div class="or-separator"><i>or</i></div>
    @for (provider of getProviders(); track provider) {
      <div style="text-align: center; width: 275px; margin: 5px 10px;">
        <a href="/auth/{{provider.providerLink}}" class="mat-raised-button on-hover-white-color" [ngClass]="provider.providerName" style="padding: 15px; border-radius: 5px;">
          <i class="fab fa-{{provider.providerIcon}}"
            style="margin: 4px 15px 0 5px;">
            </i> Sign in with <b>{{provider.providerName}}</b></a>
          </div>
        }
        <div style="margin-top: 30px;">
          <i class="fas fa-file-pdf fa-3x" style="color: red" aria-hidden="true"></i>
          <a style="padding-left: 20px;" href="" target="_blank">Click Here For Portal User Guide</a>
        </div>
      </mat-card>
    </div>
    <!--<div class="big-container">
    <div class="wrapper">
      <form class="form-signin" (ngSubmit)="onSubmit()" >
        <h2 class="text-center">Login with:</h2>
        <div class="list-group">
          <div >
            <p>
              <input type="text" id="username" name="username" class="form-control login-input" placeholder="email" required="" autofocus="" [(ngModel)]="credentials.username">
            </p>
            <p>
              <input type="password" id="textMessage" name="textMessage" class="form-control login-input" placeholder="Password" required="" [(ngModel)]="credentials.textMessage">
            </p>
            <button class="btn btn-ezf btn-block" type="submit">Sign in</button>
          </div>
          <div class="or-seperator"><i>or</i></div>
          <h5 class="text-center">Sign in with</h5>
          <div class="text-center social-btn" *ngFor="let provider of getProviders()">
            <a href="/auth/{{provider.providerLink}}" class="btn btn-block" [ngClass]="provider.providerName"><i class="fab fa-{{provider.providerIcon}}"></i> Sign in with <b>{{provider.providerName}}</b></a>
          </div>
        </div>
      </form>
    </div>
  </div>-->
